import BoxIcon from "@redotech/redo-icons/box-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import {
  AdvancedTableFilter,
  ArrayStringTableFilter,
} from "@redotech/redo-web/advanced-filters/advanced-filter";

export const BinFilter = (
  fetcher: (
    { filters }: { filters: AdvancedTableFilter[] },
    signal: AbortSignal,
  ) => Promise<string[]>,
): ArrayStringTableFilter<string> => ({
  type: AdvancedFilterType.ARRAY_TO_STRING,
  operators: [
    ArrayStringFilterOperator.ANY_OF,
    ArrayStringFilterOperator.ALL_OF,
    ArrayStringFilterOperator.NONE_OF,
    ArrayStringFilterOperator.STARTS_WITH,
    ArrayStringFilterOperator.DOES_NOT_START_WITH,
  ],
  data: {
    name: "bin",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "bin",
  Icon: BoxIcon,
  valueFetcher: fetcher,
  dbSearch: true,
  displayName: "Bin",
});
